import { useEventListener } from './useEventListener';
export var EventListener = /*#__PURE__*/function () {
  function EventListener(props) {
    useEventListener(props);
    return null;
  }
  EventListener.defaultProps = {
    capture: false
  };
  return EventListener;
}();
//# sourceMappingURL=EventListener.js.map
